<div class="position-relative search-field-container {{ extraClasses }}">
  <input type="text" class="input-field" placeholder="{{ placeholder }}" (input)="onValueChange($event)" />
  <div class="d-flex align-items-center justify-content-center position-absolute icon-container">
    <img src="../../../../assets/magnifying_glass_icon.svg" alt="magnifying glass icon" />
  </div>
</div>
